import React from "react";
import { Form } from "react-bootstrap";

class CustomCheckbox extends React.PureComponent {
    render() {
        return (
            <Form.Check
                {...this.props}
            />
        );
    }
}

export default CustomCheckbox;
